import React from "react";
import PropTypes from "prop-types";
import ComboHeader from "../ComboHeader/ComboHeader";

export const CardHeader = ({
  app,
  titleId,
  hardTitle,
  subtitle,
  hardSubtitle,
  tooltip,
  legends,
  radio,
  classStyle,
  scale,
}) => {
  return (
    <ComboHeader
      app={app}
      reference={{
        title: {
          id: titleId,
          hard: hardTitle,
        },
        subtitle: {
          id: subtitle,
          hard: hardSubtitle,
        },
      }}
      tooltip={tooltip}
      legends={legends}
      radio={radio}
      classStyle={classStyle}
      scale={scale}
    />
  );
};

CardHeader.propTypes = {
  app: PropTypes.object,
  titleId: PropTypes.string,
  hardTitle: PropTypes.string,
  subtitle: PropTypes.string,
  hardSubtitle: PropTypes.string,
  tooltip: PropTypes.string,
  legends: PropTypes.array,
  radio: PropTypes.bool,
  classStyle: PropTypes.object,
  scale: PropTypes.number,
};
